<template>
    <div class="box-field" :class="{ error: error }" style="white-space: nowrap">
        <input
            type="text"
            class="form-control form-control_name"
            :disabled="disabled"
            :error="error"
            :value="$store.getters.total"
            @input="input($event.target.value)"
            > {{$store.getters.currencySymbol}} 
            <p 
                class="help-text"
                v-if="$store.getters.selectedCryptoCurrencySymbol"
                >
                ≈ {{($store.getters.total * $store.getters.rateMultipliers[$store.getters.selectedCryptoCurrencySymbol]).toFixed($store.getters.allowedCryptocurrencies[$store.getters.selectedCryptoCurrencySymbol]["precision"])}} 
                {{$store.getters.selectedCryptoCurrencySymbol}}</p>
    </div>
</template>
<script>
export default {
    name: "AmountInput",
    props: {
        value: {
            type: String,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        },
        error: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        input(text) {
            text = text.replaceAll(/[^0-9]/g, '').replace(/^0+/, '').replace(/(......).*/, '$1');
            this.$store.dispatch('setTotal', (text == '') ? null : parseInt(text));
        },
    },
};
</script>
